import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import React from "react";

function CommentsPopUp({ stateprops }) {
    const { visible, setVisible, asmComments, rsmComments, csmComments } =
        stateprops;
    return (
        <div>
            <Dialog
                header="Comments"
                visible={visible}
                style={{ width: "50vw" }}
                onHide={() => {
                    setVisible(false);
                }}
                closable={false}
                draggable={false}
                resizable={false}
            >
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="d-block mb-2">
                        <label className="form-label">ASM Comments</label>
                        <InputTextarea
                            className="form-control"
                            type="text"
                            value={asmComments}
                            disabled
                        />
                    </div>
                    <div className="d-block mb-2">
                        <label className="form-label">RSM Comment</label>
                        <InputTextarea
                            className="form-control"
                            type="text"
                            value={rsmComments}
                            disabled
                        />
                    </div>
                    <div className="d-block mb-2">
                        <label className="form-label">CSM Comment</label>
                        <InputTextarea
                            className="form-control"
                            type="text"
                            value={csmComments}
                            disabled
                        />
                    </div>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="text-end mt-4">
                        <button
                            type="button"
                            className="btn btn-cancel-red"
                            onClick={() => setVisible(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>

            </Dialog>
        </div>
    );
}

export default CommentsPopUp;
